import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted, {"position":"bottom-right","duration":4000,"theme":"toasted-primary"})

export default function (ctx, inject) {
  inject('toast', Vue.toasted)
}